import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary-600 text-white">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="text-2xl font-bold mb-4">Vulpes</h3>
            <p className="text-white/90 leading-relaxed">Cadernos de Campo Digitais e Rega Inteligente para Espaços Verdes.</p>
          </div>
          <div className="footer-section">
            <h3 className="text-lg font-bold mb-4">Links Úteis</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/#hero" className="text-white/90 hover:text-white transition-all duration-200 inline-flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-4 h-0.5 bg-white transition-all duration-200"></span>
                  Início
                </Link>
              </li>
              <li>
                <Link to="/#products" className="text-white/90 hover:text-white transition-all duration-200 inline-flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-4 h-0.5 bg-white transition-all duration-200"></span>
                  Produtos/Serviços
                </Link>
              </li>
              <li>
                <Link to="/#about" className="text-white/90 hover:text-white transition-all duration-200 inline-flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-4 h-0.5 bg-white transition-all duration-200"></span>
                  Sobre
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/90 hover:text-white transition-all duration-200 inline-flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-4 h-0.5 bg-white transition-all duration-200"></span>
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/#contact" className="text-white/90 hover:text-white transition-all duration-200 inline-flex items-center gap-2 group">
                  <span className="w-0 group-hover:w-4 h-0.5 bg-white transition-all duration-200"></span>
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="text-lg font-bold mb-4">Contacto</h3>
            <div className="space-y-3">
              <p className="text-white/90 flex items-center gap-2 hover:text-white transition-colors duration-200">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>hello@vulpes.pt</span>
              </p>
              <p className="text-white/90 flex items-center gap-2 hover:text-white transition-colors duration-200">
                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>+351 969 059 898</span>
              </p>
            </div>
          </div>
        </div>
        <div className="footer-bottom border-t border-white/30 pt-6 mt-8">
          <p className="text-white/90 text-center text-sm">© 2025 Vulpes - 2Gf Innovation Systems, Lda. Todos os direitos reservados.</p>
          <div className="footer-legal-links mt-4 flex gap-6 justify-center flex-wrap">
            <Link
              to="/privacidade"
              className="text-white/80 hover:text-white text-sm transition-colors duration-200 relative group"
            >
              Política de Privacidade
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white group-hover:w-full transition-all duration-300"></span>
            </Link>
            <span className="text-white/50">|</span>
            <Link
              to="/cookies"
              className="text-white/80 hover:text-white text-sm transition-colors duration-200 relative group"
            >
              Política de Cookies
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-white group-hover:w-full transition-all duration-300"></span>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
